export const OK = "OK";
export const ERROR = "ERROR";
export const INIT = "INIT";
export type STATUS = typeof OK | typeof ERROR | typeof INIT;

// All our store sub components have this interface at a minimum
export interface StoreState<T> {
  data: T;
  form: T;
  submitRequired: boolean;
  loadingGet: boolean;
  loadingPost: boolean;
  status: STATUS;
  statusMessage: string;
}

export interface Action<Type = string> {
  type: Type;
}

export interface StoreDispatchProps<T> {
  fetch: (data?: Partial<T>) => any;
  edit: (data?: Partial<T>) => any;
}

// TODO - key extends StoreState
export const storeInit = <T>(data: T): StoreState<T> => {
  return {
    data: Object.assign(data instanceof Array ? [] : {}, data),
    form: Object.assign(data instanceof Array ? [] : {}, data),
    submitRequired: false,
    loadingGet: false,
    loadingPost: false,
    status: "INIT",
    statusMessage: ""
  };
};
